<template>
    <v-main>
        <v-parallax
            src="https://firebasestorage.googleapis.com/v0/b/yukimi-pino.appspot.com/o/shattered-island.gif?alt=media&token=7ca02a16-3ad1-4445-88f2-acf33616bdd8"
        >
            <v-row
            align="center"
            justify="center"
            >
            <v-col
                class="text-center"
                cols="12"
            >
                <h1 class="display-1 font-weight-thin mb-4">
                
                Welcome!
                
                </h1>
                <h4 class="subheading">
                
                this is 0yu 's portofolio
                
                </h4>
            </v-col>
            </v-row>
        </v-parallax>
    </v-main>
</template>

<script>
    export default {
        name: "Home",
        components: {},
    };
</script>
